import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessUnitInvoiceInformationModel } from '../business-unit-invoice-information.model';
import {
    fiInvoiceMethodType,
    fiInvoiceMethodTypes,
} from '@fi-app/customer-billing/customer-billing-invoice/invoice-method-type';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { BillingService } from '../../billing.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-business-unit-invoice-information-view',
    templateUrl: './business-unit-invoice-information-view.component.html',
    styleUrls: ['./business-unit-invoice-information-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-invoice-information-view' },
    standalone: false,
})
export class BusinessUnitInvoiceInformationViewComponent implements OnInit {
    @Input() invoiceInformation: BusinessUnitInvoiceInformationModel;
    editTabs: EditTabsModel;

    constructor(
        private contentLanguages: ContentLanguagesService,
        private billingService: BillingService,
        private appTextService: AppTextService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('billing.invoice_information'),
            this.appTextService.get('back'),
        );
    }

    editBusinessUnitInvoiceInfo() {
        this.fiStateService.go(FiStateNames.Billing.Payment.InvoiceInformation.Edit);
    }

    isInvoiceMethodEmail(): boolean {
        return this.invoiceInformation.InvoiceMethodType === fiInvoiceMethodType.Email;
    }

    isInvoiceMethodPostalAddress(): boolean {
        return this.invoiceInformation.InvoiceMethodType === fiInvoiceMethodType.PostalAddress;
    }

    getLanguageLabel(languageId: number): string {
        // const applicationLanguages = this.contentLanguages.GetApplicationLanguages();
        //
        // for(let i = 0; i < applicationLanguages.length; i++){
        //     if(applicationLanguages[i].Id === languageId)
        //         return applicationLanguages[i].Name;
        // }

        return this.contentLanguages.GetApplicationLanguages().find((applicationLanguages: IContentLanguage) => {
            return applicationLanguages.Id === languageId;
        })?.Name;
    }

    getCurrencyLabel(currencyId: CurrencyType): string {
        // const billingCurrencies = this.billingService.GetBillingCurrencies();
        //
        // for (let i = 0; i < billingCurrencies.length; i++) {
        //     if (billingCurrencies[i].Id === currencyId)
        //         return billingCurrencies[i].Name;
        // }

        return this.billingService
            .GetBillingCurrencies()
            .find((billingCurrency: { Id: CurrencyType; Name: String }) => {
                return billingCurrency.Id === currencyId;
            })?.Name;
    }

    getInvoiceMethodTypeLabel(methodTypeId: fiInvoiceMethodType): string {
        // const types = fiInvoiceMethodTypes;
        //
        // for (let i = 0; i < types.length; i++) {
        //     if (types[i].id === methodTypeId)
        //         return this.appTextService.get( types[i].textId);
        // }

        const invoiceMethodTypeTextId: string = fiInvoiceMethodTypes.find(
            (invoiceMethodType: { id: fiInvoiceMethodType; textId: string }) => invoiceMethodType.id === methodTypeId,
        )?.textId;
        return this.appTextService.get(invoiceMethodTypeTextId);
    }
}
